import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetEquipmentPanel from './CharacterSheetEquipmentPanel.vue';
import CharacterSheetEquipmentAdder from './CharacterSheetEquipmentAdder.vue';
import CharacterSheetEquipmentCustomAdder from './CharacterSheetEquipmentCustomAdder.vue';
import ValueEditor from '@/components/ValueEditor.vue';
let CharacterSheetEquipment = class CharacterSheetEquipment extends Vue {
};
__decorate([
    Prop(Array)
], CharacterSheetEquipment.prototype, "equipment", void 0);
__decorate([
    Prop(Array)
], CharacterSheetEquipment.prototype, "customEquipment", void 0);
__decorate([
    Prop(Object)
], CharacterSheetEquipment.prototype, "attunement", void 0);
__decorate([
    Prop(Number)
], CharacterSheetEquipment.prototype, "credits", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheetEquipment.prototype, "isBuilder", void 0);
CharacterSheetEquipment = __decorate([
    Component({
        components: {
            CharacterSheetEquipmentPanel,
            CharacterSheetEquipmentAdder,
            CharacterSheetEquipmentCustomAdder,
            ValueEditor
        }
    })
], CharacterSheetEquipment);
export default CharacterSheetEquipment;
